import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import s from './FullScreenModal.module.css';
import { useSelector } from 'react-redux';
import { selectSelectedImage } from '../../../../store/selectors/imageSelectors';
import IconFullScreen from '../../../../shared/ui/icons/IconFullScreen';
import DownloadButton from '../../../text-editor-page/widgets/tools-buttons/DownloadButton';
import RetryButton from '../../../text-editor-page/widgets/tools-buttons/RetryButton';
import { useAppDispatch } from '../../../../store/store';
import { toggleActivePrompt } from '../../../../store/slices/pageSlice';
import FullScreenButton from '../../../text-editor-page/widgets/tools-buttons/FullScreenButton';

function parseSize(sizeStr: string, fallbackWidth: number, fallbackHeight: number) {
    if (typeof sizeStr === 'string' && sizeStr.includes('x')) {
        const [w, h] = sizeStr.split('x').map(Number);
        if (!isNaN(w) && !isNaN(h)) return { width: w, height: h };
    }
    return { width: fallbackWidth, height: fallbackHeight };
}

const FullScreenModal = () => {
    const dispatch = useAppDispatch();
    const selectedImage = useSelector(selectSelectedImage);

    const [container] = React.useState(() => {
        let el = document.getElementById('fullscreen-modal-root');
        if (!el) {
            el = document.createElement('div');
            el.id = 'fullscreen-modal-root';
            document.body.appendChild(el);
        }
        return el;
    });

    console.log('presets', selectedImage?.image?.transformation?.presets);

    const { width: imgWidth, height: imgHeight } = parseSize(
        selectedImage?.image?.transformation?.presets?.size ?? '',
        selectedImage?.image?.transformation?.width ?? 0,
        selectedImage?.image?.transformation?.height ?? 0,
    );

    return ReactDOM.createPortal(
        <div className={s.container}>
            <div className={s.bar}>
                <div className={s.bar_left}>
                    <p className={s.text}>Image size</p>
                    <p className={s.thin_text}>
                        {selectedImage?.image?.transformation?.presets?.size ||
                            `${selectedImage?.image?.transformation?.width}×${selectedImage?.image?.transformation?.height}`}
                    </p>
                </div>

                <div className={s.bar_right}>
                    <RetryButton mode={'image'} />
                    <DownloadButton />
                    <FullScreenButton />
                </div>
            </div>
            <div className={s.image_container}>
                <img
                    src={selectedImage?.image?.url}
                    alt="Full Screen"
                    style={{
                        width: `${imgWidth}px`,
                        height: `${imgHeight}px`,
                        objectFit: 'cover',
                    }}
                />
            </div>
        </div>,
        container,
    );
};

export default FullScreenModal;
